import { render, staticRenderFns } from "./UserTypes.vue?vue&type=template&id=1951fc20&scoped=true"
import script from "./UserTypes.vue?vue&type=script&lang=js"
export * from "./UserTypes.vue?vue&type=script&lang=js"
import style0 from "./UserTypes.vue?vue&type=style&index=0&id=1951fc20&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1951fc20",
  null
  
)

export default component.exports